// extracted by mini-css-extract-plugin
export default {"icon":"TableFileName_icon__fTbuh"};